import React, { useState, useEffect, useCallback } from "react";
import {
  collection,
  doc,
  runTransaction,
  getDoc,
  getDocs,
  query,
  where,
  deleteDoc,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { db } from "../config/Firebase"; // Import db for Firestore operations
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function InventoryManage() {
  const [productImages, setProductImages] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [category, setCategory] = useState("DesignerMetal_MetalFrame");
  const [brand, setBrand] = useState("Rayban");
  const [shape, setShape] = useState("Round");
  const [productId, setProductId] = useState("");
  const [material, setMaterial] = useState("");
  const [frameColor, setFrameColor] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [cost, setCost] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [status, setStatus] = useState("Available");
  const [branch, setBranch] = useState("ADMIN");
  const [adminSelectedBranch, setAdminSelectedBranch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [products, setProducts] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentType, setCurrentType] = useState("frames"); // 'frames' | 'lens' | 'contactlens' | 'sunglassess' | 'accessories' | 'storeinventory' | 'serviceaccessories' | 'all'
  const [editingId, setEditingId] = useState(null);
  const [showExportMenu, setShowExportMenu] = useState(false);

  const branchOptions = ["ChinnaSalem", "Thuraiyur", "Thammampatti"];

  const getCollectionName = (type) => {
    switch (type) {
      case "frames":
        return "Local Inventory";
      case "lens":
        return "Lens Local";
      case "contactlens":
        return "ContactLens Local";
      case "sunglassess":
        return "sunglassess local";
      case "accessories":
        return "Accessories Local";
      case "storeinventory":
        return "Store Inventory Local";
      case "serviceaccessories":
        return "Service Accessories Local";
      default:
        return "Local Inventory";
    }
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case "frames":
        return "Frames";
      case "lens":
        return "Lens";
      case "contactlens":
        return "Contact Lens";
      case "sunglassess":
        return "Sunglasses";
      case "accessories":
        return "Accessories";
      case "storeinventory":
        return "Store Inventory";
      case "serviceaccessories":
        return "Service Accessories";
      case "all":
        return "All Items";
      default:
        return "Frames";
    }
  };

  const getCategoryOptions = (type) => {
    switch (type) {
      case "frames":
        return [
          { value: "DesignerMetal_MetalFrame", label: "Designer Metal & Metal Frame" },
          { value: "FrameLess", label: "Frame Less" },
          { value: "FullFrame", label: "Full Frame" },
          { value: "HalfFrame", label: "Half Frame" },
          { value: "SafetyGlassess", label: "Safety Glasses" },
          { value: "Sunglassess", label: "Sunglasses" },
          { value: "Kids-Frame", label: "Kids Frame" },
          { value: "Kids-Sunglass", label: "Kids Sunglass" },
          { value: "Accessories", label: "Accessories" },
        ];
      case "sunglassess":
        return [
          { value: "Polarized", label: "Polarized" },
          { value: "Non-Polarized", label: "Non-Polarized" },
          { value: "UV Protection", label: "UV Protection" },
          { value: "Sports", label: "Sports" },
          { value: "Fashion", label: "Fashion" },
          { value: "Aviator", label: "Aviator" },
          { value: "Wayfarer", label: "Wayfarer" },
          { value: "Cat-Eye", label: "Cat-Eye" },
          { value: "Round", label: "Round" },
          { value: "Square", label: "Square" },
          { value: "Oversized", label: "Oversized" },
          { value: "Gradient", label: "Gradient" },
          { value: "Mirrored", label: "Mirrored" },
          { value: "Classic", label: "Classic" },
          { value: "Designer", label: "Designer" },
        ];
      case "storeinventory":
        return [
          { value: "Fluorescent strip", label: "Fluorescent strip" },
          { value: "Schirmer strip", label: "Schirmer strip" },
          { value: "Proparacaine", label: "Proparacaine" },
          { value: "Aurominde", label: "Aurominde" },
          { value: "Buds", label: "Buds" },
          { value: "Needle", label: "Needle" },
          { value: "NS", label: "NS" },
          { value: "AR roll", label: "AR roll" },
          { value: "Cloth box", label: "Cloth box" },
          { value: "Nail polish remover", label: "Nail polish remover" },
          { value: "Order book", label: "Order book" },
          { value: "Bill book", label: "Bill book" },
          { value: "Cellotape", label: "Cellotape" },
          { value: "Pen", label: "Pen" },
          { value: "Carbon paper", label: "Carbon paper" },
          { value: "Pen marker", label: "Pen marker" },
          { value: "Monitor remote battery", label: "Monitor remote battery" },
          { value: "Colin", label: "Colin" },
          { value: "Tissue paper", label: "Tissue paper" },
          { value: "Mask", label: "Mask" },
          { value: "Sanitiser", label: "Sanitiser" },
          { value: "Gloves", label: "Gloves" },
        ];
      case "serviceaccessories":
        return [
          { value: "Needle screw", label: "Needle screw" },
          { value: "Nosepad screw", label: "Nosepad screw" },
          { value: "Gen screw", label: "Gen screw" },
          { value: "Nosepad", label: "Nosepad" },
          { value: "RL nosepad", label: "RL nosepad" },
          { value: "Fix nosepad", label: "Fix nosepad" },
          { value: "RL Bush", label: "RL Bush" },
          { value: "Nose player", label: "Nose player" },
          { value: "Cutter", label: "Cutter" },
          { value: "Supra Wire", label: "Supra Wire" },
          { value: "Minus screwdriver", label: "Minus screwdriver" },
          { value: "Plus screwdriver", label: "Plus screwdriver" },
          { value: "Pin needle", label: "Pin needle" },
          { value: "Frame Strap", label: "Frame Strap" },
          { value: "3 piece remover", label: "3 piece remover" },
          { value: "3 piece player", label: "3 piece player" },
          { value: "Wax", label: "Wax" },
        ];
      case "accessories":
        return [
          { value: "Virtue lens cleaner spray", label: "Virtue lens cleaner spray" },
          { value: "Zeiss lens cleaning kit", label: "Zeiss lens cleaning kit" },
          { value: "Zeiss wipes", label: "Zeiss wipes" },
          { value: "Zeiss anti fog kit", label: "Zeiss anti fog kit" },
          { value: "Bio true 60ml & 120ml", label: "Bio true 60ml & 120ml" },
          { value: "Renu 120ml", label: "Renu 120ml" },
          { value: "Renu rewetting drops", label: "Renu rewetting drops" },
          { value: "Dewmat Gel", label: "Dewmat Gel" },
          { value: "Maycool", label: "Maycool" },
          { value: "I Tone", label: "I Tone" },
          { value: "Matmox", label: "Matmox" },
          { value: "Moxiflip LP", label: "Moxiflip LP" },
          { value: "Tobaris", label: "Tobaris" },
          { value: "CL kit", label: "CL kit" },
          { value: "CL case", label: "CL case" },
          { value: "White punk", label: "White punk" },
          { value: "Black punk", label: "Black punk" },
          { value: "Welding glass", label: "Welding glass" },
          { value: "Safety glass white", label: "Safety glass white" },
          { value: "Pocket box", label: "Pocket box" },
          { value: "Sunglass pouch", label: "Sunglass pouch" },
          { value: "Branded box", label: "Branded box" },
          { value: "Reading glass", label: "Reading glass" },
        ];
      case "contactlens":
        return [
          { value: "Power sph", label: "Power sph" },
          { value: "Power toric", label: "Power toric" },
          { value: "Cosmetic", label: "Cosmetic" },
          { value: "Prosthetics", label: "Prosthetics" },
        ];
      case "lens":
        return [
          { value: "wt-s", label: "wt-s" },
          { value: "G-s", label: "G-s" },
          { value: "B-s", label: "B-s" },
          { value: "BB-s", label: "BB-s" },
          { value: "UVB-s", label: "UVB-s" },
          { value: "GD-s", label: "GD-s" },
          { value: "Gy-P", label: "Gy-P" },
          { value: "GG-P", label: "GG-P" },
          { value: "GB-P", label: "GB-P" },
          { value: "RT-w", label: "RT-w" },
          { value: "RT-g", label: "RT-g" },
          { value: "RT-b", label: "RT-b" },
          { value: "RT-wp", label: "RT-wp" },
          { value: "RT-gp", label: "RT-gp" },
          { value: "RT-bp", label: "RT-bp" },
          { value: "MF-w", label: "MF-w" },
          { value: "MF-g", label: "MF-g" },
          { value: "MF-b", label: "MF-b" },
          { value: "MF-BB", label: "MF-BB" },
          { value: "MF-advdri", label: "MF-advdri" },
          { value: "MF-Gd", label: "MF-Gd" },
          { value: "MF-wp", label: "MF-wp" },
          { value: "MF-gp", label: "MF-gp" },
          { value: "MF-bbp", label: "MF-bbp" },
          { value: "MF-MG, MG-s", label: "MF-MG, MG-s" },
        ];
      default:
        return [];
    }
  };

  const getProductImages = (product) => {
    const urls = [];
    for (let i = 1; i <= 5; i++) {
      const imgUrl = product[`ImageUrl${i}`];
      if (imgUrl) urls.push(imgUrl);
    }
    return urls;
  };

  const isSimplifiedForm = () => currentType !== "frames";

  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const username = localStorage.getItem('currentUsername');
        if (!username) {
          setBranch('ADMIN');
          return;
        }
        // First, try LDB
        const ldbDoc = await getDoc(doc(db, 'LDB', username));
        if (ldbDoc.exists()) {
          const ldbData = ldbDoc.data();
          if (ldbData.branch) {
            setBranch(ldbData.branch);
            return;
          }
        }
        // Fallback to LUB
        const lubDoc = await getDoc(doc(db, 'LUB', username));
        if (lubDoc.exists()) {
          const lubData = lubDoc.data();
          if (lubData.branch) {
            setBranch(lubData.branch);
            return;
          }
        }
        // Default to ADMIN
        setBranch('ADMIN');
      } catch (error) {
        console.error('Error fetching branch:', error);
        setBranch('ADMIN');
      }
    };
    fetchBranch();
  }, []);

  const fetchProducts = useCallback(async () => {
    if (!branch) {
      setError("No branch allocated.");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const branchToQuery = branch === 'ADMIN' ? adminSelectedBranch : branch;
      if (branch === 'ADMIN' && !branchToQuery) {
        setError("Please select a branch to view products.");
        setIsLoading(false);
        return;
      }
      
      const fetchedProducts = [];
      
      const fetchFromCollection = async (collectionName) => {
        let q;
        if (branchToQuery === 'ALL') {
          q = query(collection(db, collectionName));
        } else {
          q = query(collection(db, collectionName), where("Branch", "==", branchToQuery));
        }
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((docSnap) => {
          fetchedProducts.push({
            id: docSnap.id,
            __collection: collectionName,
            ...docSnap.data()
          });
        });
      };

      if (currentType === "all") {
        const allTypes = ["frames", "lens", "contactlens", "sunglassess", "accessories", "storeinventory", "serviceaccessories"];
        const collectionNames = allTypes.map(getCollectionName);
        const uniqueCollections = [...new Set(collectionNames)];
        await Promise.all(uniqueCollections.map(fetchFromCollection));
      } else {
        await fetchFromCollection(getCollectionName(currentType));
      }
      
      setProducts(fetchedProducts);
    } catch (err) {
      setError(`Error fetching products: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  }, [branch, currentType, adminSelectedBranch]);

  // Auto-fetch products when branch or type is set
  useEffect(() => {
    if (branch && (branch !== 'ADMIN' || adminSelectedBranch)) {
      fetchProducts();
    }
  }, [branch, adminSelectedBranch, currentType, fetchProducts]);

  // NEW: Auto-set status to "Sold" when quantity becomes 0
  useEffect(() => {
    const qty = parseInt(quantity) || 0;
    if (qty === 0) {
      setStatus("Sold");
    }
  }, [quantity]);

  const resetForm = () => {
    setProductImages([]);
    setImageUrls([]);
    setProductId("");
    setMaterial("");
    setFrameColor("");
    setName("");
    setDescription("");
    setCost("");
    setQuantity(1);
    setStatus("Available");
    setCategory("DesignerMetal_MetalFrame");
    setBrand("Rayban");
    setShape("Round");
    setEditingId(null);
    setError("");
    // Do not reset adminSelectedBranch so admin can continue working on the same branch
  };

  const handleTypeChange = (type) => {
    setCurrentType(type);
    setShowAddForm(false);
    resetForm();
  };

  const handleEdit = (product) => {
    setEditingId(product.id);
    setProductId(product.ProductID);
    setName(product.Name || '');
    setDescription(product.Description || '');
    setCost(product.Cost?.toString() || '');
    setQuantity(product.Quantity?.toString() || '1');
    setStatus(product.Status || 'Available');
    setCategory(product.Category || getCategoryOptions(currentType)[0]?.value || '');
    if (!isSimplifiedForm()) {
      setMaterial(product.Material || '');
      setFrameColor(product.FrameColor || '');
      setShape(product.Shape || 'Round');
      setBrand(product.Brand || 'Rayban');
    }
    const imgs = getProductImages(product);
    setImageUrls(imgs);
    setProductImages(imgs);
    // When admin edits from "All Branches" view, set the branch to the product's actual branch
    if (branch === 'ADMIN' && product.Branch) {
      setAdminSelectedBranch(product.Branch);
    }
    setShowAddForm(true);
    setError('');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this product?')) return;
    setIsLoading(true);
    setError('');
    try {
      const collectionName = getCollectionName(currentType);
      await deleteDoc(doc(db, collectionName, id));
      alert('Product deleted successfully');
      fetchProducts();
    } catch (err) {
      setError(`Delete error: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (!files.length) return;

    setIsLoading(true);
    setError("");

    try {
      const storage = getStorage();
      const newUrls = [];
      const previews = [];

      for (const file of files) {
        if (!file.type.startsWith("image/")) {
          setError("Only image files are allowed.");
          setIsLoading(false);
          return;
        }
        const uniqueName = `${Date.now()}-${file.name}`;
        const storageRef = ref(storage, `products/${uniqueName}`);
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);
        newUrls.push(url);
        previews.push(URL.createObjectURL(file));
      }

      setImageUrls((prev) => [...prev, ...newUrls]);
      setProductImages((prev) => [...prev, ...previews]);
    } catch (err) {
      setError(`Upload error: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAdd = async () => {
    const qty = parseInt(quantity);
    // Validation
    if (
      imageUrls.length === 0 ||
      !productId.trim() ||
      !name.trim() ||
      !description.trim() ||
      !cost.trim() ||
      isNaN(parseFloat(cost)) ||
      parseFloat(cost) <= 0 ||
      isNaN(qty) ||
      qty < 0
    ) {
      setError("Please complete all fields, upload at least one image, and provide a valid quantity (0 or greater).");
      return;
    }

    if (branch === 'ADMIN' && !adminSelectedBranch) {
      setError("Please select a branch for this product.");
      return;
    }

    if (branch === 'ADMIN' && adminSelectedBranch === 'ALL') {
      setError("Please select a specific branch (not 'All Branches') to save a product.");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const collectionName = getCollectionName(currentType);
      const colRef = collection(db, collectionName);
      const docRef = doc(colRef, productId);

      let data = {
        ProductID: productId,
        Name: name,
        Description: description,
        Cost: parseFloat(cost),
        Quantity: qty,
        Status: qty === 0 ? "Sold" : status, // Enforce status based on quantity
        Branch: branch === 'ADMIN' ? adminSelectedBranch : branch,
      };

      // Add Category for all types
      data.Category = category;

      if (!isSimplifiedForm()) {
        // Full fields for frames
        data.Material = material;
        data.FrameColor = frameColor;
        data.Shape = shape;
        data.Brand = brand;
      }

      imageUrls.forEach((url, i) => (data[`ImageUrl${i + 1}`] = url));

      await runTransaction(db, async (tx) => {
        const snap = await tx.get(docRef);
        if (editingId) {
          if (!snap.exists()) throw new Error("Product not found.");
          tx.update(docRef, data);
        } else {
          if (snap.exists()) throw new Error("Product ID already exists.");
          tx.set(docRef, data);
        }
      });

      const action = editingId ? 'updated' : 'added';
      alert(`Product ${action} successfully to ${getTypeLabel(currentType)}!`);
      // reset
      setEditingId(null);
      resetForm();
      setShowAddForm(false);
      // Refresh products list
      fetchProducts();
    } catch (err) {
      setError(`Database error: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelForm = () => {
    resetForm();
    setShowAddForm(false);
  };

  const exportToCSV = () => {
    if (filteredProducts.length === 0) return;
    const headers = ["Product ID", "Name", "Category", "Brand", "Cost", "Quantity", "Branch", "Status"];
    const rows = filteredProducts.map(p => [
      p.ProductID || "",
      p.Name || "",
      p.Category || "",
      p.Brand || "",
      p.Cost || "",
      p.Quantity || "",
      p.Branch || "",
      p.Status || ""
    ].map(v => `"${String(v).replace(/"/g, '""')}"`).join(","));
    
    const csvContent = [headers.join(","), ...rows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Inventory_Export_${new Date().getTime()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setShowExportMenu(false);
  };

  const exportToPDF = () => {
    if (filteredProducts.length === 0) return;
    const doc = new jsPDF();
    doc.text(`Inventory Report - ${getTypeLabel(currentType)}`, 14, 15);
    
    const tableColumn = ["ID", "Name", "Category", "Brand", "Cost", "Qty", "Branch", "Status"];
    const tableRows = [];

    filteredProducts.forEach(p => {
      const row = [
        p.ProductID || "",
        p.Name || "",
        p.Category || "",
        p.Brand || "",
        p.Cost || "",
        p.Quantity || "",
        p.Branch || "",
        p.Status || ""
      ];
      tableRows.push(row);
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [0, 0, 0] }
    });
    
    doc.save(`Inventory_Export_${new Date().getTime()}.pdf`);
    setShowExportMenu(false);
  };

  // Filter products based on search term
  const filteredProducts = products.filter(product =>
    product.ProductID.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (product.Brand && product.Brand.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Get first image URL for each product
  const getProductImage = (product) => {
    for (let i = 1; i <= 5; i++) { // Assuming up to 5 images
      const imgUrl = product[`ImageUrl${i}`];
      if (imgUrl) return imgUrl;
    }
    return null; // No image
  };

  const renderSimplifiedForm = () => (
    <div>
      {/* Image Preview & Upload */}
      <div className="grid grid-cols-3 gap-4 mb-8">
        {productImages.map((src, idx) => (
          <img
            key={idx}
            src={src}
            alt={`Preview ${idx + 1}`}
            className="w-full h-40 object-cover rounded-md border border-gray-200"
          />
        ))}
        <label
          htmlFor="upload"
          className="flex items-center justify-center border-2 border-dashed border-gray-300 rounded-md cursor-pointer hover:border-gray-400 transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            className="w-10 h-10 text-gray-400"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </label>
        <input
          id="upload"
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageUpload}
          className="hidden"
        />
      </div>

      {/* Simplified Form Fields */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block text-gray-700 font-medium mb-1">Category</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          >
            {getCategoryOptions(currentType).map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Product ID</label>
          <input
            type="text"
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Branch</label>
          {branch === 'ADMIN' ? (
            <select
              value={adminSelectedBranch}
              onChange={(e) => setAdminSelectedBranch(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              <option value="">Select a branch</option>
              <option value="ALL">All Branches</option>
              {branchOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              value={branch}
              readOnly
              className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
            />
          )}
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Cost (₹)</label>
          <input
            type="number"
            value={cost}
            onChange={(e) => setCost(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Quantity</label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min="0"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-gray-700 font-medium mb-1">Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Status</label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            disabled={parseInt(quantity) === 0} // Disable if quantity is 0
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200 disabled:bg-gray-100 disabled:cursor-not-allowed"
          >
            <option>Available</option>
            <option>Sold</option>
          </select>
        </div>
      </div>
    </div>
  );

  const renderFullForm = () => (
    <div>
      {/* Image Preview & Upload */}
      <div className="grid grid-cols-3 gap-4 mb-8">
        {productImages.map((src, idx) => (
          <img
            key={idx}
            src={src}
            alt={`Preview ${idx + 1}`}
            className="w-full h-40 object-cover rounded-md border border-gray-200"
          />
        ))}
        <label
          htmlFor="upload"
          className="flex items-center justify-center border-2 border-dashed border-gray-300 rounded-md cursor-pointer hover:border-gray-400 transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            className="w-10 h-10 text-gray-400"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </label>
        <input
          id="upload"
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageUpload}
          className="hidden"
        />
      </div>

      {/* Full Form Fields for Frames */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block text-gray-700 font-medium mb-1">Category</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          >
            {getCategoryOptions(currentType).map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Branch</label>
          {branch === 'ADMIN' ? (
            <select
              value={adminSelectedBranch}
              onChange={(e) => setAdminSelectedBranch(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              <option value="">Select a branch</option>
              <option value="ALL">All Branches</option>
              {branchOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              value={branch}
              readOnly
              className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
            />
          )}
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Product ID</label>
          <input
            type="text"
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Material</label>
          <input
            type="text"
            value={material}
            onChange={(e) => setMaterial(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Frame Color</label>
          <input
            type="text"
            value={frameColor}
            onChange={(e) => setFrameColor(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Cost (₹)</label>
          <input
            type="number"
            value={cost}
            onChange={(e) => setCost(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Quantity</label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min="0"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-gray-700 font-medium mb-1">Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Shape</label>
          <select
            value={shape}
            onChange={(e) => setShape(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          >
            <option>Round</option>
            <option>Oval</option>
            <option>Square</option>
            <option>Rectangular</option>
            <option>Cat-Eye</option>
            <option>Butterfly</option>
            <option>Hexagonal</option>
            <option>Aviator</option>
            <option>Wayfarer</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Brand</label>
          <select
            value={brand}
            onChange={(e) => setBrand(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
          >
            <option>Generic</option>
            <option>Rayban</option>
            <option>Nova</option>
            <option>Carrera</option>
            <option>Police</option>
            <option>Boss</option>
            <option>Mont blanc</option>
            <option>Tom ford</option>
            <option>Vogue</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">Status</label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            disabled={parseInt(quantity) === 0} // Disable if quantity is 0
            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200 disabled:bg-gray-100 disabled:cursor-not-allowed"
          >
            <option>Available</option>
            <option>Sold</option>
          </select>
        </div>
      </div>
    </div>
  );

  const renderTableHeaders = () => (
    <tr className="bg-gray-50 text-gray-600 uppercase text-[10px] sm:text-xs tracking-wider">
      <th className="px-3 py-3 font-semibold text-left">Image</th>
      <th className="px-3 py-3 font-semibold text-left">Product</th>
      {!isSimplifiedForm() && (
        <th className="px-3 py-3 font-semibold text-left hidden lg:table-cell">Details</th>
      )}
      <th className="px-3 py-3 font-semibold text-left">Stock & Price</th>
      <th className="px-3 py-3 font-semibold text-left">Location</th>
      <th className="px-3 py-3 font-semibold text-center">Actions</th>
    </tr>
  );

  const renderTableRow = (product, idx) => (
    <tr key={idx} className="hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0">
      <td className="px-3 py-3 whitespace-nowrap w-16">
        {getProductImage(product) ? (
          <img
            src={getProductImage(product)}
            alt={product.Name}
            className="w-10 h-10 object-cover rounded-lg shadow-sm border border-gray-200"
          />
        ) : (
          <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-[10px] text-gray-400 font-medium">N/A</div>
        )}
      </td>
      
      <td className="px-3 py-3">
        <div className="flex flex-col">
           <span className="font-bold text-gray-900 text-sm">{product.Name}</span>
           <div className="flex items-center gap-2 mt-0.5">
             <span className="text-[10px] sm:text-xs font-mono text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded">{product.ProductID}</span>
             <span className="text-[10px] sm:text-xs text-blue-600 font-medium truncate max-w-[100px]">{product.Category}</span>
           </div>
        </div>
      </td>
      
      {!isSimplifiedForm() && (
        <td className="px-3 py-3 hidden lg:table-cell">
           <div className="flex flex-wrap gap-1 max-w-[200px]">
              {product.Brand && <span className="text-[10px] bg-white border border-gray-200 text-gray-700 px-1.5 py-0.5 rounded-md shadow-sm">{product.Brand}</span>}
              {product.Shape && <span className="text-[10px] bg-white border border-gray-200 text-gray-700 px-1.5 py-0.5 rounded-md shadow-sm">{product.Shape}</span>}
              {product.Material && <span className="text-[10px] bg-white border border-gray-200 text-gray-700 px-1.5 py-0.5 rounded-md shadow-sm">{product.Material}</span>}
              {product.FrameColor && <span className="text-[10px] bg-white border border-gray-200 text-gray-700 px-1.5 py-0.5 rounded-md shadow-sm">{product.FrameColor}</span>}
           </div>
        </td>
      )}
      
      <td className="px-3 py-3 whitespace-nowrap">
         <div className="flex flex-col gap-1 items-start">
            <span className="font-semibold text-gray-900 text-sm">₹{product.Cost}</span>
            <span className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-bold shadow-sm ${product.Quantity > 0 ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'}`}>
               Qty: {product.Quantity || 0}
            </span>
         </div>
      </td>
      
      <td className="px-3 py-3 whitespace-nowrap">
         <div className="flex flex-col gap-1 items-start">
            <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold shadow-sm ${product.Status === 'Available' ? 'bg-green-100 text-green-800 border border-green-200' : 'bg-gray-100 text-gray-800 border border-gray-200'}`}>
              {product.Status}
            </span>
            <span className="text-[10px] sm:text-xs text-gray-600 font-medium flex items-center gap-1">
               <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-gray-400" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" /></svg>
               {product.Branch}
            </span>
         </div>
      </td>
      
      <td className="px-3 py-3 whitespace-nowrap text-center">
        <div className="flex justify-center gap-1.5">
           <button
             onClick={() => handleEdit(product)}
             className="p-1.5 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 hover:text-black transition shadow-sm border border-gray-200"
             title="Edit"
           >
             <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
           </button>
           <button
             onClick={() => handleDelete(product.id)}
             className="p-1.5 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition shadow-sm border border-red-100"
             title="Delete"
           >
             <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
           </button>
        </div>
      </td>
    </tr>
  );

  return (
    <div className="w-full min-h-full p-4 md:p-8 bg-white">
      <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-8">Inventory Management</h1>

      {/* Type Tabs */}
      <div className="flex flex-wrap items-center gap-2 mb-8 p-1 bg-gray-100 rounded-xl shadow-inner w-full">
        {[
          { key: "all", label: "ALL" },
          { key: "frames", label: "Frames" },
          { key: "lens", label: "Lens" },
          { key: "contactlens", label: "Contact Lens" },
          { key: "sunglassess", label: "Sunglasses" },
          { key: "accessories", label: "Accessories" },
          { key: "storeinventory", label: "Store Inventory" },
          { key: "serviceaccessories", label: "Service Accessories" },
        ].map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTypeChange(tab.key)}
            className={`flex-1 min-w-[120px] px-4 py-2.5 rounded-lg text-sm md:text-base font-semibold transition-all duration-200 ${
              currentType === tab.key
                ? "bg-white text-black shadow-md transform scale-[1.02]"
                : "text-gray-500 hover:text-gray-800 hover:bg-gray-50"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Add Item Section */}
      <div className="border-b pb-8 mb-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          {editingId ? `Edit ${name}` : `Add New ${getTypeLabel(currentType)}`}
        </h2>

        {!showAddForm ? (
          currentType !== "all" && (
            <button
              onClick={() => setShowAddForm(true)}
              className="px-6 py-3 bg-black text-white font-semibold rounded-lg hover:bg-gray-700 transition"
            >
              Add New {getTypeLabel(currentType)}
            </button>
          )
        ) : (
          <div>
            {error && (
              <div className="bg-red-100 text-red-700 px-4 py-2 rounded mb-6 text-center">
                {error}
              </div>
            )}

            {isSimplifiedForm() ? renderSimplifiedForm() : renderFullForm()}

            <div className="flex gap-4">
              <button
                onClick={handleAdd}
                disabled={isLoading}
                className="flex-1 py-3 bg-gray-800 text-white font-semibold rounded-lg hover:bg-gray-900 transition"
              >
                {isLoading ? "Saving..." : (editingId ? `Update ${getTypeLabel(currentType)}` : `Add ${getTypeLabel(currentType)}`)}
              </button>
              <button
                onClick={handleCancelForm}
                className="px-6 py-3 bg-black text-white font-semibold rounded-lg hover:bg-gray-800 transition"
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Products Section */}
      <div>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">{branch === 'ADMIN' && adminSelectedBranch === 'ALL' ? 'All Branches' : 'My Branch'} {getTypeLabel(currentType)} ({branch === 'ADMIN' ? (adminSelectedBranch === 'ALL' ? 'All Branches' : adminSelectedBranch || 'Select a branch') : branch})</h2>

        {/* Branch Selector for Admin */}
        {branch === 'ADMIN' && (
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-1">Select Branch</label>
            <select
              value={adminSelectedBranch}
              onChange={(e) => setAdminSelectedBranch(e.target.value)}
              className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              <option value="">Select a branch</option>
              <option value="ALL">All Branches</option>
              {branchOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
        )}

        <div className="flex flex-col md:flex-row gap-4 mb-6 items-center justify-between">
          <div className="w-full md:w-1/2">
            <input
              type="text"
              placeholder="Search by Product ID, Name, or Brand..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-black shadow-sm"
            />
          </div>
          
          <div className="flex w-full md:w-auto gap-3">
            <button
              onClick={fetchProducts}
              disabled={isLoading}
              className="flex-1 md:flex-none px-6 py-3 bg-gray-100 text-black font-semibold rounded-xl hover:bg-gray-200 transition border border-gray-200 shadow-sm"
            >
              {isLoading ? "Fetching..." : "Refresh"}
            </button>
            
            <div className="relative flex-1 md:flex-none">
               <button
                  onClick={() => setShowExportMenu(!showExportMenu)}
                  className="w-full md:w-auto px-6 py-3 bg-black text-white font-semibold rounded-xl hover:bg-gray-800 transition flex items-center justify-center gap-2 shadow-sm"
               >
                  Export ▾
               </button>
               {showExportMenu && (
                  <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-xl shadow-xl z-50 overflow-hidden">
                     <button 
                        onClick={exportToCSV}
                        className="block w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-black border-b border-gray-100"
                     >
                        Export as CSV (Excel)
                     </button>
                     <button 
                        onClick={exportToPDF}
                        className="block w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-black"
                     >
                        Export as PDF
                     </button>
                  </div>
               )}
            </div>
          </div>
        </div>

        {filteredProducts.length > 0 && (
          <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
            <table className="min-w-full bg-white text-sm">
              <thead className="bg-gray-50">{renderTableHeaders()}</thead>
              <tbody className="divide-y divide-gray-100">
                {filteredProducts.map((product, idx) => renderTableRow(product, idx))}
              </tbody>
            </table>
          </div>
        )}

        {filteredProducts.length === 0 && !isLoading && ((branch !== 'ADMIN') || (branch === 'ADMIN' && adminSelectedBranch)) && (
          <p className="text-black text-center">
            {searchTerm ? 'No products match the search.' : `No ${getTypeLabel(currentType).toLowerCase()} found for ${branch === 'ADMIN' ? (adminSelectedBranch === 'ALL' ? 'all branches' : adminSelectedBranch) : branch}.`}
          </p>
        )}
      </div>
    </div>
  );
}